import axios from '_u/axios'

// 订单列表
export const orderList = (body) => {
    return axios.post('api/order/info/list', body)
}

//新增订单
export const orderAdd = (body) => {
    return axios.post('api/order/info/add', body)
}

//删除订单
export const orderDelete = (id) => {
    return axios.post('api/order/info/delete', { id })
}

// 订单详情
export const orderView= (id) => {
    return axios.post('api/order/info/view', {id})
}

// 修改订单
export const orderUpdate = (body) => {
    return axios.post('api/order/info/update', body)
}


